import { useContext, createContext } from 'react';

/**
 * Send component stylesheet to server using context.
 *
 * @param {string} stylesheet
 */

const sendStyles = stylesheet => {
  const collect = useContext(StyleContext);
  if (collect) collect(stylesheet);
};

const context = /*#__PURE__*/createContext("asphalt");
const Provider = context.Provider;
const Consumer = context.Consumer;
const StyleContext = /*#__PURE__*/createContext();
const StyleProvider = StyleContext.Provider;
const StyleConsumer = StyleContext.Consumer;

export default context;
export { Consumer, Provider, StyleConsumer, StyleContext, StyleProvider, sendStyles };
